module.exports = {
  Interaction: require('./base'),
  PieSelect: require('./pie-select'),
  IntervalSelect: require('./interval-select'),
  Swipe: require('./swipe'),
  Pan: require('./pan'),
  Pinch: require('./pinch')
};